module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/common/icon_plus-abd55062f284dcd9ff8dd30e9d46a391.png";